import {MessageType} from "./enums/MessageType";
import {MessageEventType} from "./enums/MessageEventType";

export interface IInitMessages {
    messages: IMessage[];
    customerId: string;
    loadPrevChat: boolean
}

export interface ILocation {
    longitude: number,
    latitude: number
}

export interface IMessage {
    messageType: MessageType;
    timeSent: Date;
    text: string;
    chatId: number;
    videoUrl: string,
    location?: ILocation;
    imageId: string;
    customerId: string;
    fileId: string;
    file: IFile;
    buttons: IButton[];
    isRead: boolean;
    event: MessageEventType;
    eventDescription: string;
    operatorModel: IOperatorInfo;
    tag: string;
    needClearMessagesHistory: boolean;
    contentType: MessageContentType;
    externalId: string;
}

export interface IButton {
    text: string,
    value: string,
    contentType: ButtonContentType
}

export interface IFile {
    fileId: string;
    mimeType: string;
    name: string;
}

export interface IOperatorInfo {
    displayName: string;
    avatarId: string | null;
    type: OperatorType;
}

export enum OperatorType {
    Operator = 1,
    Bot,
    Supervisor
}

export enum ButtonContentType {
    Text = 1,
    Link,
    Trigger,
    CustomEvent
}

export enum MessageContentType {
    Text = 1,
    Markup = 2,
    Video = 3,
    Audio = 4,
    Navigation = 5,
    TextToSpeech = 6
}